import { cn } from "@/utils/cn";

interface MealPreferenceListEmptyProps {
  message: string;
  className?: string;
}

export const MealPreferenceListEmpty = ({
  message,
  className,
}: MealPreferenceListEmptyProps) => (
  <div
    className={cn(
      "rounded-3xl border border-dashed border-gray-200 bg-white px-5 py-6 text-center text-sm text-gray-500 pb-safe",
      className,
    )}
  >
    {message}
  </div>
);
